<template>
  <v-data-table
    :headers="headers"
    :items="fleet"
    :loading="isFetching"
    :items-per-page="5"
    :items-per-page-text="$t('data_tables.rows_per_page')"
    :no-data-text="$t('data_tables.no_data')"
    :sort-by="['licence_plate']"
  >
    <template v-slot:item="props">
      <tr
        v-if="props.item.is_internal===true"
        class="clickableTableRow"
        @click="gotoDetail(props.item.id)"
      >
        <td>{{props.item.licence_plate}}</td>
        <td>{{props.item.name}}</td>
        <td>
          <!-- {{props.item.status}} -->
          <span v-if="props.item.status === 'active'">{{$t('fleet.active')}}</span>
          <span v-else class="accent--text">{{$t('fleet.parked')}}</span>
        </td>
        <td class="text-right">{{props.item.properties.vehicle_dimensions | dimensionValue}}</td>
        <td class="text-right">{{props.item.properties.case_max_weight}}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'VehicleListTable',
  props: {
    fleet: Array,
    isFetching: Boolean
  },
  data () {
    return {
      headers: [
        { text: this.$i18n.t('fleet.licence_plate'), value: 'licence_plate', sortable: true },
        { text: this.$i18n.t('fleet.name'), value: 'name', sortable: true },
        { text: this.$i18n.t('fleet.status'), value: 'status', sortable: true },
        { text: this.$i18n.t('fleet.dims'), value: 'vehicle_dimensions', align: 'right', sortable: true },
        { text: this.$i18n.t('fleet.weight'), value: 'case_max_weight', align: 'right', sortable: true }
      ]
    }
  },
  methods: {
    gotoDetail (id) {
      this.$emit('go-to-detail', id)
    }
  }
}
</script>

<style>
</style>
